// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useLocales } from "react-localized"
import { IonCol, IonGrid, IonText, IonRow, IonButton } from "@ionic/react"


interface ContainerProps {
  error: string
}


const FatalErrorContainer: React.FC<ContainerProps> = ({
  error
}) => {
  const params = new URLSearchParams(window.location.search)
  const {gettext} = useLocales()
  let message: string | React.ReactElement
  let title: string
  switch(error) {
    case "temporarily_unavailable":
      title = gettext("Tijdelijk niet beschikbaar")
      message = (
        <>
          <span>{gettext("Deze functionaliteit is tijdelijk niet beschikbaar. Probeer het later opnieuw.")}</span>
        </>
      )
      break
    default:
      title = gettext("Er ging iets mis")
      message = gettext("Probeer het later opnieuw. Als het probleem aanhoudt, neem dan contact op met de klantenservice of supportafdeling.")
  }

  return (
    <>
      <IonGrid style={{paddingTop: "var(--section-padding)"}}>
        <IonRow className="main">
          <IonCol size="6">
            <IonText>
              <h2>{gettext("Er ging iets mis")}</h2>
              <p>{message}</p>
            </IonText>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <IonButton
              fill="clear"
              onClick={() => {
                params.delete('error')
                window.history.replaceState(
                  {},
                  document.title,
                  `${window.location.pathname}?${params.toString()}`
                  )
              }}
            >
              {gettext("Sluiten")}
            </IonButton>
          </IonCol>
        </IonRow>
      </IonGrid>
    </>
  )
}

export {FatalErrorContainer}